export default __webpack_public_path__ + "static/media/imperf.9991daa4.jpeg";